import RequestStatus from "../model/RequestStatus";
import {
    GetDecisionTableNamesResponse,
    GetDecisionTableConfigResponse,
    SaveDecisionTableConfigResponse,
    DeleteDecisionTableConfigResponse
} from "src/model/DecisionTableConfig";
import {
    FETCH_DECISION_TABLE_NAMES_START,
    FETCH_DECISION_TABLE_NAMES_SUCCESS,
    FETCH_DECISION_TABLE_NAMES_FAILED,
    FetchDecisionTableNamesCompleteAction,
    FETCH_DECISION_TABLE_CONFIG_START,
    FETCH_DECISION_TABLE_CONFIG_SUCCESS,
    FETCH_DECISION_TABLE_CONFIG_FAILED,
    FetchDecisionTableConfigCompleteAction,
    SAVE_DECISION_TABLE_CONFIG_START,
    SAVE_DECISION_TABLE_CONFIG_SUCCESS,
    SAVE_DECISION_TABLE_CONFIG_FAILED,
    SaveDecisionTableConfigCompleteAction,
    CREATE_DECISION_TABLE_CONFIG_START,
    CREATE_DECISION_TABLE_CONFIG_SUCCESS,
    CREATE_DECISION_TABLE_CONFIG_FAILED,
    CreateDecisionTableConfigCompleteAction,
    DELETE_DECISION_TABLE_CONFIG_START,
    DELETE_DECISION_TABLE_CONFIG_SUCCESS,
    DELETE_DECISION_TABLE_CONFIG_FAILED,
    RESET_DELETE_DECISION_TABLE_CONFIG_STATE,
    DeleteDecisionTableConfigCompleteAction,
    ResetDeleteDecisionTableConfigStateAction,
    RESET_SAVE_DECISION_TABLE_CONFIG_STATE,
    RESET_CREATE_DECISION_TABLE_CONFIG_STATE,
    ResetSaveDecisionTableConfigStateAction,
    ResetCreateDecisionTableConfigStateAction
} from "src/actions/DecisionTableConfigActions";

// Decision Table Names Reducer
const decisionTableNamesInitialState: GetDecisionTableNamesResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export const DecisionTableNamesReducer = (
    state: GetDecisionTableNamesResponse = decisionTableNamesInitialState,
    action: FetchDecisionTableNamesCompleteAction
): GetDecisionTableNamesResponse => {
    switch (action.type) {
        case FETCH_DECISION_TABLE_NAMES_START:
            return {
                requestStatus: RequestStatus.LOADING,
                data: null,
            };
        case FETCH_DECISION_TABLE_NAMES_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: action.data,
            };
        case FETCH_DECISION_TABLE_NAMES_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
            };
        default:
            return state;
    }
};

// Fee Configuration Query Reducer
const DecisionTableConfigQueryInitialState: GetDecisionTableConfigResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export const DecisionTableConfigQueryReducer = (
    state: GetDecisionTableConfigResponse = DecisionTableConfigQueryInitialState,
    action: FetchDecisionTableConfigCompleteAction
): GetDecisionTableConfigResponse => {
    switch (action.type) {
        case FETCH_DECISION_TABLE_CONFIG_START:
            return {
                requestStatus: RequestStatus.LOADING,
                data: null,
            };
        case FETCH_DECISION_TABLE_CONFIG_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: action.data,
            };
        case FETCH_DECISION_TABLE_CONFIG_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
            };
        default:
            return state;
    }
};

// Fee Configuration Save Reducer
const DecisionTableConfigSaveInitialState: SaveDecisionTableConfigResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export const DecisionTableConfigSaveReducer = (
    state: SaveDecisionTableConfigResponse = DecisionTableConfigSaveInitialState,
    action: SaveDecisionTableConfigCompleteAction | ResetSaveDecisionTableConfigStateAction
): SaveDecisionTableConfigResponse => {
    switch (action.type) {
        case SAVE_DECISION_TABLE_CONFIG_START:
            return {
                requestStatus: RequestStatus.UPDATING,
                data: null,
            };
        case SAVE_DECISION_TABLE_CONFIG_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: (action as SaveDecisionTableConfigCompleteAction).data,
            };
        case SAVE_DECISION_TABLE_CONFIG_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
                error: (action as SaveDecisionTableConfigCompleteAction).error,
            };
        case RESET_SAVE_DECISION_TABLE_CONFIG_STATE:
            return DecisionTableConfigSaveInitialState;
        default:
            return state;
    }
};

// Fee Configuration Create Reducer
const DecisionTableConfigCreateInitialState: SaveDecisionTableConfigResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export const DecisionTableConfigCreateReducer = (
    state: SaveDecisionTableConfigResponse = DecisionTableConfigCreateInitialState,
    action: CreateDecisionTableConfigCompleteAction | ResetCreateDecisionTableConfigStateAction
): SaveDecisionTableConfigResponse => {
    switch (action.type) {
        case CREATE_DECISION_TABLE_CONFIG_START:
            return {
                requestStatus: RequestStatus.UPDATING,
                data: null,
            };
        case CREATE_DECISION_TABLE_CONFIG_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: (action as CreateDecisionTableConfigCompleteAction).data,
            };
        case CREATE_DECISION_TABLE_CONFIG_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
                error: (action as CreateDecisionTableConfigCompleteAction).error,
            };
        case RESET_CREATE_DECISION_TABLE_CONFIG_STATE:
            return DecisionTableConfigCreateInitialState;
        default:
            return state;
    }
};

// Fee Configuration Delete Reducer
const DecisionTableConfigDeleteInitialState: DeleteDecisionTableConfigResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
};

export const DecisionTableConfigDeleteReducer = (
    state: DeleteDecisionTableConfigResponse = DecisionTableConfigDeleteInitialState,
    action: DeleteDecisionTableConfigCompleteAction | ResetDeleteDecisionTableConfigStateAction
): DeleteDecisionTableConfigResponse => {
    switch (action.type) {
        case DELETE_DECISION_TABLE_CONFIG_START:
            return {
                requestStatus: RequestStatus.UPDATING,
            };
        case DELETE_DECISION_TABLE_CONFIG_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
            };
        case DELETE_DECISION_TABLE_CONFIG_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                error: (action as DeleteDecisionTableConfigCompleteAction).error,
            };
        case RESET_DELETE_DECISION_TABLE_CONFIG_STATE:
            return DecisionTableConfigDeleteInitialState;
        default:
            return state;
    }
};
